import { type HTMLAttributes, type PropsWithChildren } from 'react'

import cn from 'util/cn'

const ItemFlex = (props: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => (
  <div className='flex min-w-0 items-center justify-between' {...props} />
)

interface IDropDownSearchItem {
  prefix?: React.ReactNode
  suffix?: React.ReactNode
  title: string
  description?: string
  onClick?: () => void
  iconShape?: 'circle' | 'square'
}

const SearchItem = ({
  prefix,
  suffix,
  title,
  description,
  iconShape = 'circle',
  onClick
}: IDropDownSearchItem) => {
  return (
    <div className='cursor-pointer'>
      <ItemFlex onClick={onClick}>
        <ItemFlex>
          <div
            className={cn(
              '[>img]:object-cover isolate flex h-[48px] w-[48px] flex-shrink-0 items-center justify-center overflow-hidden bg-background-2nd text-playseeGray-gray2',
              iconShape === 'circle' ? 'rounded-full' : 'rounded-[6px]'
            )}
          >
            {prefix}
          </div>

          <div className='max-h-[48px] min-w-0 flex-shrink'>
            <p className='mx-[8px] overflow-hidden text-ellipsis whitespace-nowrap text-md font-semibold text-label-l1'>
              {title}
            </p>
            {description && (
              <p className='mx-[8px] line-clamp-2 break-all text-sm text-label-l2'>
                {description}
              </p>
            )}
          </div>
        </ItemFlex>

        {suffix}
      </ItemFlex>
    </div>
  )
}

export default SearchItem
